import * as Yup from 'yup'



Yup.addMethod(Yup.string, "valida_patente", function (errorMessage) {
    return this.test(`valida_patente`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            //var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}|[a-zA-Z]{2,3}[0-9]{3}|[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
export const validationSchemas = (montoNetoCompara) => {
   
    let validationObject = { };
   
  
      validationObject["fechaEnvioCarta"] = Yup.date().required('La Fecha es obligatoria.');
     
      validationObject["idSiniestroIM"] = Yup.string().required('Este Campo es obligatorio.');
      validationObject["idCompaniaIM"] = Yup.string().required('Este Campo es obligatorio.');
      validationObject["porcConvenio"] = Yup.number().min(0, "El porciento no puede ser negativo").max(100,"El porciento no puede ser mayor a 100");
      validationObject["montoRecobro"] = Yup.string().test(
        "len",
        "No puede ser mayor a monto neto",
        (val) => {
          if (val === undefined) {
            return true;
          }
          return parseInt(val.replace(/\./g, '')) >= 0 && parseInt(val.replace(/\./g, ''))  <= montoNetoCompara;
        }
      );
      validationObject["patenteIM"] = Yup.string().test(
        "len",
        "La Patente no es válida",
        (val) => {
          if (val === undefined) {
            return true;
          }
          return val.length === 0 || (val.length >= 2 && val.length <= 7);
        }
      ).required("La Patente es obligatoria").valida_patente("La Patente no es válida");
     
     validationObject["detalleDescripcionIM"] = Yup.string().test(
       "len",
       "No puede exeder 1000 caracteres..",
       (val) => {
         if (val === undefined) {
           return true;
         }
         return val.length === 0 || (val.length >= 0 && val.length <= 1000);
       }
     );
     
      
  
    return Yup.object().shape(validationObject);
  }
  
 

